<ng-container *ngIf="!production">
  <div
    class="wo-env-info is-hidden-mobile"
    *ngIf="env$ | async as env"
  >{{ env }}</div>
</ng-container>
